import React, { useState } from 'react';
import { Container, Row, Col, Form, Button, Alert, Spinner } from 'react-bootstrap';
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope, FaClock } from 'react-icons/fa';
import axios from 'axios';
import './Contact.css';

const Contact = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        message: ''
    });

    const [validated, setValidated] = useState(false);
    const [showSuccess, setShowSuccess] = useState(false);
    const [showError, setShowError] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const form = e.currentTarget;

        if (form.checkValidity() === false) {
            e.stopPropagation();
            setValidated(true);
            return;
        }

        setValidated(true);
        setIsLoading(true);
        setShowError(false);
        setErrorMessage('');

        try {
            // İletişim verilerini API'ye gönder - Başvuru formundan farklı endpoint
            const response = await axios.post('/api/contact/send', formData);

            if (response.data && response.data.success) {
                // Başarılı iletişim durumunda
                console.log('Mesaj başarıyla gönderildi:', response.data);
                setShowSuccess(true);
                setFormData({ name: '', email: '', phone: '', message: '' });
                setValidated(false);
            } else {
                // API başarılı yanıt vermedi
                setShowError(true);
                setErrorMessage(response.data?.message || 'Mesaj gönderilirken bir hata oluştu.');
            }
        } catch (error) {
            console.error('Mesaj gönderme hatası:', error);
            setShowError(true);
            setErrorMessage(
                error.response?.data?.message ||
                'Mesaj işlenirken bir hata oluştu. Lütfen daha sonra tekrar deneyin.'
            );
        } finally {
            setIsLoading(false);

            // 5 saniye sonra başarı mesajını kaldır
            if (showSuccess) {
                setTimeout(() => {
                    setShowSuccess(false);
                }, 5000);
            }
        }
    };

    return (
        <div className="contact-page">
            <div className="contact-header py-5">
                <Container>
                    {/* Başlık ve altına sarı çizgi eklendi - Diğer sayfalarla uyumlu */}
                    <div className="text-center mb-4">
                        <h1 className="page-title mb-2">İLETİŞİM</h1>
                        <div className="title-underline"></div>
                        <p className="text-center lead mt-4">Bizimle iletişime geçin, sorularınızı yanıtlayalım.</p>
                    </div>
                </Container>
            </div>

            <section className="contact-info-section py-5">
                <Container>
                    <Row>
                        <Col lg={3} md={6} className="mb-4">
                            <div className="contact-info-card">
                                <div className="contact-icon">
                                    <FaMapMarkerAlt />
                                </div>
                                <h4>Adres</h4>
                                <p>Kaynarca Mah. Zirve Sok., Optimum Modern Sitesi No:1, 34890 Pendik/İstanbul</p>
                            </div>
                        </Col>

                        <Col lg={3} md={6} className="mb-4">
                            <div className="contact-info-card">
                                <div className="contact-icon">
                                    <FaPhoneAlt />
                                </div>
                                <h4>Telefon</h4>
                                <p>+90 (532) 387 30 91</p>
                            </div>
                        </Col>

                        <Col lg={3} md={6} className="mb-4">
                            <div className="contact-info-card">
                                <div className="contact-icon">
                                    <FaEnvelope />
                                </div>
                                <h4>E-posta</h4>
                                <p>otoprime34@gmail.com</p>
                            </div>
                        </Col>

                        <Col lg={3} md={6} className="mb-4">
                            <div className="contact-info-card">
                                <div className="contact-icon">
                                    <FaClock />
                                </div>
                                <h4>Çalışma Saatleri</h4>
                                <p>Pazartesi - Cumartesi: 09:00 - 18:00</p>
                                <p>Pazar: Kapalı</p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            <section className="map-section py-5 bg-light">
                <Container>
                    <Row>
                        <Col lg={6} className="mb-4 mb-lg-0">
                            <div className="contact-form-container">
                                <h3 className="mb-4">Bize Mesaj Gönderin</h3>

                                {showSuccess && (
                                    <Alert variant="success" onClose={() => setShowSuccess(false)} dismissible>
                                        Mesajınız başarıyla gönderildi. En kısa sürede size dönüş yapacağız.
                                    </Alert>
                                )}

                                {showError && (
                                    <Alert variant="danger" onClose={() => setShowError(false)} dismissible>
                                        {errorMessage || 'Mesajınız gönderilirken bir hata oluştu. Lütfen tekrar deneyin.'}
                                    </Alert>
                                )}

                                <Form noValidate validated={validated} onSubmit={handleSubmit}>
                                    <Form.Group className="mb-3" controlId="contactName">
                                        <Form.Label>Adınız Soyadınız</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="name"
                                            value={formData.name}
                                            onChange={handleChange}
                                            required
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            Lütfen adınızı giriniz.
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    <Form.Group className="mb-3" controlId="contactEmail">
                                        <Form.Label>E-posta Adresiniz</Form.Label>
                                        <Form.Control
                                            type="email"
                                            name="email"
                                            value={formData.email}
                                            onChange={handleChange}
                                            required
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            Lütfen geçerli bir e-posta adresi giriniz.
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    <Form.Group className="mb-3" controlId="contactPhone">
                                        <Form.Label>Telefon</Form.Label>
                                        <Form.Control
                                            type="tel"
                                            name="phone"
                                            value={formData.phone}
                                            onChange={handleChange}
                                            required
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            Lütfen telefon numaranızı giriniz.
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    <Form.Group className="mb-3" controlId="contactMessage">
                                        <Form.Label>Mesajınız</Form.Label>
                                        <Form.Control
                                            as="textarea"
                                            rows={5}
                                            name="message"
                                            value={formData.message}
                                            onChange={handleChange}
                                            required
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            Lütfen mesajınızı giriniz.
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    <Button
                                        variant="primary"
                                        type="submit"
                                        className="w-100 py-2"
                                        disabled={isLoading}
                                    >
                                        {isLoading ? (
                                            <>
                                                <Spinner
                                                    as="span"
                                                    animation="border"
                                                    size="sm"
                                                    role="status"
                                                    aria-hidden="true"
                                                    className="me-2"
                                                />
                                                Gönderiliyor...
                                            </>
                                        ) : (
                                            "Gönder"
                                        )}
                                    </Button>
                                </Form>
                            </div>
                        </Col>

                        <Col lg={6}>
                            <div className="map-container">
                                <h3 className="mb-4">Bizi Ziyaret Edin</h3>
                                <div className="google-map">
                                    <iframe
                                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3014.7218240582106!2d29.240124115775256!3d40.92364867930942!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14cac5351c2bfa95%3A0x10daee34f31d2d25!2sKaynarca%2C%20Pendik%2F%C4%B0stanbul!5e0!3m2!1str!2str!4v1620565848175!5m2!1str!2str"
                                        width="100%"
                                        height="400"
                                        style={{ border: 0 }}
                                        allowFullScreen=""
                                        loading="lazy"
                                        title="Otoprime Konum"
                                    ></iframe>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </div>
    );
};

export default Contact;